export function buildSbomCandidates(sbomId, sbomName) {
  const candidates = [];
  const push = (value) => {
    if (!value || candidates.includes(value)) return;
    candidates.push(value);
  };

  if (sbomName) push(sbomName);
  if (sbomId) {
    push(sbomId);
    push(sbomId.endsWith('-sbom.json') ? sbomId : `${sbomId}-sbom.json`);
  }

  return candidates;
}

export function resolveSbomFileName(sbomId, sboms = []) {
  if (!sbomId) return '';
  if (sbomId.endsWith('.json')) return sbomId;

  const selected = sboms.find((sbom) => sbom.CommitHash === sbomId);
  if (selected?.SbomLink) {
    try {
      return decodeURIComponent(new URL(selected.SbomLink).pathname.split('/').pop() || '');
    } catch (_) {
      const raw = selected.SbomLink.split('/').pop();
      if (raw) return decodeURIComponent(raw);
    }
  }

  return `${sbomId}-sbom.json`;
}
